'use client';

import { useLayoutEffect } from 'react';

export default function NavbarShadow() {
  useLayoutEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector('nav')?.parentElement;

      if (navbar) {
        if (window.scrollY > 0) {
          navbar.classList.add('scroll');
        } else {
          navbar.classList.remove('scroll');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return null;
}
